import React, { ReactNode, useState } from 'react'
import { Button, InputGroup, Modal } from '@systemeio/components'
import { useTranslation } from 'next-i18next'

export const LinkModal = ({
  linkIsEditing,
  setLinkIsEditing,
  onInsertLink,
}: {
  linkIsEditing: boolean
  setLinkIsEditing: (value: boolean) => void
  onInsertLink: (url: string) => void
}): ReactNode => {
  const { t } = useTranslation()
  const [url, setUrl] = useState('')

  const handleSaveLink = (): void => {
    if (url) {
      onInsertLink(url)
    }
    setLinkIsEditing(false)
    setUrl('')
  }
  const closeOnEnterKey = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      handleSaveLink()
    }
  }

  const onCloseDialog = (): void => {
    setLinkIsEditing(false)
    setUrl('')
  }

  return (
    <Modal.Root
      open={linkIsEditing}
      onOpenChange={open => {
        if (!open) {
          onCloseDialog()
        }
      }}
    >
      <Modal.Popup>
        <Modal.Header className="pr-16">
          <Modal.Title>{t('comments.components.comments.add_link_title')}</Modal.Title>
        </Modal.Header>
        <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-8 py-6">
          <InputGroup.Root className="w-full">
            <InputGroup.Input
              placeholder={t('comments.components.comments.link_menu_placeholder')}
              onKeyDown={closeOnEnterKey}
              value={url}
              onChange={e => setUrl(e.target.value)}
            />
          </InputGroup.Root>
        </div>
        <Modal.Footer>
          <Button variant="secondary" onClick={onCloseDialog}>
            {t('comments.components.comments.add_link_cancel')}
          </Button>
          <Button variant="primary" onClick={handleSaveLink}>
            {t('comments.components.comments.add_link_save')}
          </Button>
        </Modal.Footer>
      </Modal.Popup>
    </Modal.Root>
  )
}
